import React from "react";
import StrokeText from "./strokeText";

/* Big Heading
============================================================================= */

const BigHeading = ({ text = "Big Heading" }) => {
	// Config

	// Render
	return (
		<StrokeText
			text={text}
			size="xl:text-6xl text-5xl md:mt-20 mt-12 mb-8"
		/>
	);
};

/* Export
============================================================================= */

export default BigHeading;
